import { render, staticRenderFns } from "./DiagnosticKnowledgeHub.vue?vue&type=template&id=79b3cc64&scoped=true"
import script from "./DiagnosticKnowledgeHub.vue?vue&type=script&lang=js"
export * from "./DiagnosticKnowledgeHub.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticKnowledgeHub.vue?vue&type=style&index=0&id=79b3cc64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b3cc64",
  null
  
)

export default component.exports